import { BlockType } from '@/types/apiServerContract';

type ComponentType = object | (() => object);

class ComponentResolver {
	components = new Map<BlockType, ComponentType>();
	fallback: ComponentType | undefined;

	constructor(private context: string) {}

	register(type: BlockType, component: ComponentType) {
	    if (this.components.get(type)) {
	        throw new Error(`${this.context}: ${BlockType[type]} already registered`);
	    }
	    this.components.set(type, component);
	}

	registerFallback(component: ComponentType) {
	    this.fallback = component;
	}

	resolve(type: BlockType): ComponentType {
	    const component = this.components.get(type);
	    if (!component) {
	        if (this.fallback) {
	            console.log(`${this.context}: ${BlockType[type]} not registered, using fallback`);
	            return this.fallback;
	        } else {
	            const msg = `${this.context}: ${BlockType[type]} not registered and no default component`;
	            throw new Error(msg);
	        }
	    }
	    return component;
	}
}

export const blockResolver = new ComponentResolver('block');
export const blockEditorsResolver = new ComponentResolver('editors');
